module.exports = __webpack_public_path__ + "static/media/bryan.34f20e3b.jpg";